import { gql } from 'apollo-boost';

export const QUERY_CREDIT_SUBMISSION_PUBLIC = gql`
  query CreditSubmissionPublic($dynamicsId: ID, $creditSubmissionId: ID) {
    creditSubmissionPublic(dynamicsId: $dynamicsId, creditSubmissionId: $creditSubmissionId) {
      creditSubmissionId
      creditSubId
      contactUserProfileId
      contact
      contactName
      contactPhone
      contactEmail
      applicant
      applicantName
      applicantAddress
      amountRequested
      businessName
      submissionDate
      submittedBy
      lenderAccountId
      lenderProfileId
      lenderContactInfo {
        id
        email
        fullName
        title
        phoneNumber
        mobilePhoneNumber
      }
      lenderContactInfo {
        id
        email
        fullName
        title
        phoneNumber
        accountId
      }
    }
  }
`;